import template from './actionLink.html';
import controller from './actionLink.controller';
import './actionLink.scss';

let actionLinkComponent = {
  restrict: 'E',
  bindings: {
    click: '&',
    danger: '<'
  },
  template,
  controller,
  transclude: true
};

export default actionLinkComponent;
